import Moment from 'moment';
import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import { ISetAddProject, ISetDeleteProject, IProjectAddGroupSetAction,IProjectAutoAddGroupSetAction } from '../../models/action/project';
import * as Actions from '../constants/project';

const _logger = Log.create('Link Reducer');

const setProjectActivityData = (newState: any, projectPageAction: any  ) => {
    newState.ProjectData = {
        activityId: projectPageAction ? projectPageAction.activityId : '',
        abbreviation: projectPageAction ? projectPageAction.abbreviation : '',
        name: projectPageAction ? projectPageAction.name : '',
        allowDownload: projectPageAction ? projectPageAction.allowDownload : false,
        isGroupProject: projectPageAction ? projectPageAction.isGroupProject : true,
        description: projectPageAction ? projectPageAction.description : '',
        isCommon: projectPageAction?.isCommon ? 1 : 0,
        dateCriteria: projectPageAction ? projectPageAction.dateCriteria : 0,
        datePrerequisiteActivityHours: projectPageAction?.datePrerequisiteActivityHours ?? '',
        datePrerequisiteActivityId: projectPageAction?.datePrerequisiteActivityId ? [projectPageAction?.datePrerequisiteActivityId] : '',
        prerequisiteActivityId: projectPageAction?.prerequisiteActivityId ?? '',
        completionType: projectPageAction?.completionType ?? 1,
        completionCriteria: projectPageAction?.completionCriteria,
        alwaysOnTop: projectPageAction?.alwaysOnTop,
        subActivities: projectPageAction?.projectType,
        groupList: projectPageAction?.projectGroup,
        taskDeadline: projectPageAction?.taskDeadLine,
        taskDeadlinetime: '',
        dateRange: '',
        fileInputKey: '',
        photoUploadKey: '',
        activityConditionalBeginDate: projectPageAction?.beginDate,
        activityConditionalEndDate: projectPageAction?.endDate,
        termWeekIds: projectPageAction?.termWeekIds,
        selectedActivityOwnersTagIds: projectPageAction?.selectedActivityOwnersTagIds,
        selectedActivityUnitsTagIds: projectPageAction?.selectedActivityUnitsTagIds,
        selectedClass: projectPageAction?.selectedClass,
        allUnits: projectPageAction?.allUnits,
        courseId: projectPageAction?.courseId,
        file: projectPageAction?.file && projectPageAction?.file.length > 0 ? projectPageAction?.file : null,
        deletedFilesId: [],
        cardImgName: projectPageAction?.cardImgName,
        learningOutcomeId: projectPageAction?.learningOutcomeId,
    };
}

const projectReducer = (state = GlobalState().project, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {};
    if (action.type === Actions.actions.SET_PROJECT_ADD_GROUP) {
        const actionPayload = (action as unknown) as IProjectAddGroupSetAction;
        newState.lastCreatedGroupId = actionPayload.result;
    }
    if (action.type === Actions.actions.SET_PROJECT_AUTO_ADD_GROUP) {
        const actionPayload = (action as unknown) as IProjectAutoAddGroupSetAction;
        newState.ProjectData = {
            ...state.ProjectData,
            groupList: actionPayload.result.groups,
            remainingUsers: actionPayload.result.remainingUsers,
        };
    }
    if (action.type === Actions.actions.SET_PROJECT_DATA_DEFAULT) {
        newState.ProjectData = {
            isUpdate: false,
            isGroupProject: true,
            groupAddType: 0,
            name: '',
            description: '',
            filterActivityView: 'criterionDate',
            dateRange: '',
            selectActivity: [],
            note: 0,
            allUnits: false,
            selectUnits: [],
            subActivities: [],
            groupList: [],
            selectCondition: [],
            selectOwner: [],
            completionType: 1,
            alwaysOnTop: false,
            dateCriteria: 0,
            selectedClass: [],
            allowDownload: false,
            activitytype: '1',
            selectWeek: [],
            termWeekIds: [],
            activityTime: 0,
            selectedActivityUnitsTagIds: [],
            selectedActivityOwnersTagIds: [],
            prerequisiteActivityId: '',
            datePrerequisiteActivityId: '',
            deletedFilesId: [],
            cardImgName: '',
            learningOutcomeId: null,
        };
    }
    if (action.type === Actions.actions.SET_UPDATE_PROJECT_ACTIVITY) {
        const projectPageActionPayload = (action as unknown) as ISetAddProject;
        const projectPageAction = projectPageActionPayload?.ProjectData ? projectPageActionPayload.ProjectData[0] : null;
        setProjectActivityData(newState, projectPageAction);
    } else if (action.type === Actions.actions.DELETE_PROJECT_SET_ACTIVITY) {
        const projectPageAction = action as ISetDeleteProject;
        newState.project.deleteProjectStatus = projectPageAction.deleteProjectStatus;
    }
    return Object.assign({}, state, newState);
};

export default projectReducer;
